import { render, staticRenderFns } from "./MusicVersion.vue?vue&type=template&id=13439b38&scoped=true&"
import script from "./MusicVersion.vue?vue&type=script&lang=js&"
export * from "./MusicVersion.vue?vue&type=script&lang=js&"
import style0 from "./MusicVersion.vue?vue&type=style&index=0&id=13439b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13439b38",
  null
  
)

export default component.exports